/**
 * Registers a service worker based on webpack 5 native worker support,
 * which creates a separate chunk and updates the scriptURL on compile time.
 *
 * **Important!**
 *
 * For being able to register the worker script loaded from S3 bucket,
 * a response header has to be configured:
 * - Name: `Service-Worker-Allowed:/`
 * - Path: `/static/ui/contents/**\/service-worker.js`
 */
export async function registerServiceWorker(scope: string): Promise<ServiceWorkerRegistration> {
  return navigator.serviceWorker.register(
    /* webpackChunkName: "service-worker" */
    new URL('./service-worker.ts', import.meta.url),
    { scope }
  );
}
